"use client";
import RegisterForm from "@/components/common/drawer/AuthDrawer/components/RegisterForm";
import CommonImage from "@/components/common/image/CommonImage";
import React from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { MdKeyboardArrowRight } from "react-icons/md";
import Image from "next/image";
import Link from "next/link";

export default function Register() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <section className="login_section">
      <div className="login-section-card">
        <div className="container">
          <div className="login-breadcrumb">
            <ul>
              <li>হোম</li>
              <li><MdKeyboardArrowRight className="arrow-icon" /></li>
              <li><Link href={'#'}>রেজিস্ট্রেশন</Link></li>
            </ul>
          </div>
          <div className="login-title-card">
            <h1 className="title">
              <span className="highlighted">রেজিস্ট্রেশন করুন,</span> Focus এর অভিজ্ঞতায় যুক্ত হন
            </h1>
          </div>
        </div>
        <Image
          src={'/images/admission-icon/login-now.png'}
          alt={'login'}
          width={105}
          height={105}
          className="login_now_icon"
        />
      </div>

      <div className="container">
        <div className="login-page-card">
          <div className="login-registation-card only-registation-card">
            <div className="grid grid-cols-12 gap-6 items-center">
              <div className="lg:col-span-6 col-span-12">
                <div className="video-part">
                  <div className="top-title">
                    <Image
                      src={"/images/admission-icon/login-icon.png"}
                      className="top-icon"
                      alt="Icon"
                      width={11}
                      height={16}
                    />
                    <span className="">
                      রেজিস্ট্রেশন
                    </span>
                  </div>
                  <h2 className="second-title">কিভাবে রেজিস্ট্রেশন করবেন ?</h2>
                  <div className="login-video-thumbnail">
                    <CommonImage
                      src={
                        setting?.login_video_thumble_url ??
                        "/images/login/login-video-thumbnail.avif"
                      }
                      alt={"Image"}
                      className="login-thumbnail"
                    />
                    <div className="login-playbtn">
                      <button className="play-btn" >
                        <FaCirclePlay className="play-icon" />
                      </button>
                    </div>
                  </div>
                </div>

              </div>
              <div className="lg:col-span-6 col-span-12">
                <div className="">
                  <div className="login-form">
                    <RegisterForm setDrawerType={null} setDrawerOpen={null} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </section>
  );
}
